var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.value,
          expression: "value",
        },
      ],
      staticClass: "c-select",
      attrs: { disabled: !_vm.items.length },
      on: {
        change: [
          function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.value = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          },
          _vm.select,
        ],
      },
    },
    [
      _c("option", { domProps: { value: null } }, [
        _vm._v(_vm._s(_vm.placeholder)),
      ]),
      _vm._v(" "),
      _vm._l(_vm.items, function (item, index) {
        return _c("option", { key: index, domProps: { value: item.alias } }, [
          _vm._v("\n        " + _vm._s(item.name) + "\n    "),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }